// Rishab code
import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  Button,
  FileUploader,
  LoadPanel,
  SelectBox,
  TextArea,
} from "devextreme-react";
import CustomDropdown from "../../../../components/customDropDown/CustomDropdown";
import {
  notesDataSource,
  timeDataSource,
  custNotesDataSource,
} from "../../data";
import "./NotesPanel.scss";
import "remixicon/fonts/remixicon.css";
import "../../../../components/typographyText/styles.scss";
import CustomSlider from "../../../../components/customSlider/CustomSlider";
import CustomButton from "../../../../components/customButton/CustomButton";
import { saveNotes } from "../../../../api/ticketApi";
import { useAuth } from "../../../../contexts/auth";
import { ToastDisplayer } from "../../../../components/toastDisplay/ToastDisplayer";
import CustomEmpty from "../../../../components/customEmptyView/CustomEmpty";
import CustomHtmlEditor from "../../../../components/customHtmlEditor/CustomHtmlEditor";
import { mark } from "framer-motion/client";
import { filterNotesApi } from "../../../../api/filterAPI";

export default function NotesPanel({
  detailTicketData,
  getTicketDetails,
  isTicketClosed,
}) {
  const { user } = useAuth();
  // const bottomRef = useRef(null);
  const [ticketData, setTicketData] = useState({
    ticketsubject: "",
    ticketdescription: "",
    ticketcategorytransid: "",
    ticketsubcattransid: "",
    companytransid: "",
    ticketstatus: "",
    ticketpriority: "",
    ticketdatetime: "",
    usertransid: "",
    username: "",
    customertransid: "",
    ticketcreatedby: "",
  });
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [isSlidingOut, setIsSlidingOut] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(""); // For description input
  const [notesAttachedFile, setNotesAttachedFile] = useState("");
  const [uploaderFiles, setUploaderFiles] = useState([]);
  const [timeFilter, setTimeFilter] = useState(1); //All time = 1
  const [noteFilter, setNoteFilter] = useState("all_notes");
  const notesData = detailTicketData?.notes || [];
  const [filteredNotes, setFilteredNotes] = useState(notesData);
  const [fileError, setFileError] = useState(null);
  const [markup, setMarkup] = useState("");

  // useEffect(() => {
  //   bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [filteredNotes]);

  //notes filter api user role vise
  const fetchFilteredNotes = async (roleFilter, timeFilter) => {
    try {
      setLoading(true);

      const res = await filterNotesApi({
        ticketcode: detailTicketData?.ticket?.ticketcode,
        role_filter: roleFilter,
        filter: timeFilter, // ✅ ADD THIS
      });

      if (res.success) {
        setFilteredNotes(res.data.notes || []);
      } else {
        ToastDisplayer("error", res.message);
      }
    } catch (err) {
      ToastDisplayer("error", "Failed to fetch notes");
    } finally {
      setLoading(false);
    }
  };

  const getTimeFilterKey = (value) => {
    switch (value) {
      case 2:
        return "today";
      case 3:
        return "yesterday";
      case 4:
        return "this_week";
      case 5:
        return "this_month";
      case 6:
        return "past";
      default:
        return "all";
    }
  };

  const getNormalizedRole = (role) => {
    switch (role) {
      case "company":
        return "Company"; // Admin
      case "companyuser":
        return "Developer";
      case "customer":
        return "Customer";
      case "customercontact":
        return "Contact";
      default:
        return "Customer";
    }
  };

  const getRoleBasedFilters = (role) => {
    switch (role) {
      case "Company":
        return [
          "all_notes",
          "your_notes",
          "developer_notes",
          "customer_notes",
          "other_notes",
        ];

      case "Developer":
        return [
          "all_notes",
          "your_notes",
          "admin_notes",
          "customer_notes",
          "other_notes",
        ];

      case "Customer":
        return [
          "all_notes",
          "your_notes",
          "admin_notes",
          "developer_notes",
          "other_notes",
        ];

      case "Contact":
        return [
          "all_notes",
          "your_notes",
          "admin_notes",
          "developer_notes",
          "customer_notes",
          "other_notes",
        ];

      default:
        return ["all_notes"];
    }
  };

  const filterLabelMap = {
    all_notes: "All Notes",
    your_notes: "Your Notes",
    admin_notes: "Admin Notes",
    developer_notes: "Developer Notes",
    customer_notes: "Customer Notes",
    other_notes: "Other Notes",
  };

  const roleBasedFilters = useMemo(() => {
    const normalizedRole = getNormalizedRole(user?.userrole);
    const allowedFilters = getRoleBasedFilters(normalizedRole);

    return allowedFilters.map((key, index) => ({
      id: key, // 🔥 instead of index
      name: filterLabelMap[key],
      value: key,
    }));
  }, [user]);
  // console.log("Dropdown Data:", roleBasedFilters);
  // console.log("Selected Value:", noteFilter);
  /// rishab code
  // useEffect(() => {
  //   console.log("FULL USER OBJECT:", user);
  //   const newFilteredNotes = notesData.filter((note) => {
  //     switch (noteFilter) {
  //       case 1: // All Notes
  //         return true;

  //       case 2: // Your Notes
  //         if (user.userrole === "customer") {
  //           return note.creator_transid === user.customertransid;
  //         } else if (user.userrole === "company") {
  //           return note.userrole === "Company";
  //         } else if (user.userrole === "companyuser") {
  //           return user.usertransid === note.creator_transid;
  //         } else if (user.userrole === "Customer emp") {
  //           return note.creator_transid === user.contacttransid; // ✅ ADD THIS
  //         }
  //         return false;

  //       case 3: // Customer Notes
  //         return note.userrole === "Customer";

  //       case 4: // Other User Notes
  //         if (user.userrole === "customer") {
  //           return note.creator_transid !== user.customertransid;
  //         } else if (user.userrole === "company") {
  //           return note.userrole !== "Company" && note.userrole !== "Customer";
  //         } else if (user.userrole === "companyuser") {
  //           return (
  //             (note.userrole === "Company User" ||
  //               note.userrole === "Company") &&
  //             note.creator_transid !== user.usertransid
  //           );
  //         } else if (user.userrole === "Customer emp") {
  //           return note.creator_transid !== user.contacttransid; // ✅ ADD THIS
  //         }
  //         return false;

  //       default:
  //         return true;
  //     }
  //   });

  //   setFilteredNotes(newFilteredNotes);
  // }, [notesData, noteFilter, user]);

  useEffect(() => {
    const cleanedHtml = markup
      ?.replace(/white-space:\s*pre[^;]*;/gi, "white-space: normal;")
      ?.replace(/<pre[^>]*>/gi, "<div>")
      ?.replace(/<\/pre>/gi, "</div>")
      ?.replace(/<p><br><\/p>/gi, "")
      ?.replace(/<p>\s*<\/p>/gi, "");

    setTicketData((prev) => ({
      ...prev,
      ticketdescription: cleanedHtml,
    }));
  }, [markup]);

  const groupNotes = (notes) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // ✅ Monday as start of week
    const startOfWeek = new Date(today);
    const day = startOfWeek.getDay(); // 0 = Sunday
    const diff = startOfWeek.getDate() - (day === 0 ? 6 : day - 1);
    startOfWeek.setDate(diff);
    startOfWeek.setHours(0, 0, 0, 0);

    // ✅ Sunday as end of week
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    return notes.reduce(
      (acc, note) => {
        const noteDate = new Date(note.notesdate);
        noteDate.setHours(0, 0, 0, 0);

        if (noteDate.getTime() === today.getTime()) {
          acc.today.push(note);
        } else if (noteDate.getTime() === yesterday.getTime()) {
          acc.yesterday.push(note);
        } else if (noteDate >= startOfWeek && noteDate <= endOfWeek) {
          acc.thisWeek.push(note);
        } else {
          acc.past.push(note);
        }

        return acc;
      },
      { today: [], yesterday: [], thisWeek: [], past: [] },
    );
  };
  const groupedNotes = useMemo(
    () => groupNotes(filteredNotes),
    [filteredNotes],
  );

  const handleAddNote = () => {
    setDescription("");
    setUploaderFiles([]);
    setNotesAttachedFile("");
    setSliderOpen(true);
  };

  const handleCloseSlider = () => {
    setMarkup("");
    setNotesAttachedFile("");
    setUploaderFiles([]);
    setIsSlidingOut(true);
  };

  const handleFileChange = (e) => {
    const files = e.value || [];
    const file = files[0];

    setUploaderFiles(files); // only update once from e.value

    if (!file) {
      setFileError(null);
      setNotesAttachedFile("");
      return;
    }

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const maxSize = 1.5 * 1024 * 1024;

    let error = null;

    if (!allowedTypes.includes(file.type)) {
      error =
        "Invalid file type! Please upload PNG, JPG, JPEG, PDF, DOC, DOCX, XLS or XLSX.";
    }

    if (file.size > maxSize) {
      error = "File size exceeds 1.5MB! Please upload a smaller file.";
    }

    if (error) {
      setFileError(error);
      setNotesAttachedFile("");
      return;
    }

    setFileError(null);

    const reader = new FileReader();
    reader.onload = () => {
      setNotesAttachedFile(reader.result);
    };

    reader.readAsDataURL(file);
  };

  const handleNotesSaveDetails = async () => {
    if (fileError) {
      ToastDisplayer("error", fileError);
      return;
    }
    const isEmptyHtml = !markup || markup.replace(/<[^>]*>/g, "").trim() === "";

    if (isEmptyHtml && !notesAttachedFile) {
      ToastDisplayer(
        "error",
        "Please provide either a description or attach a file.",
      );
      return;
    }

    try {
      setLoading(true);
      let mycust = null,
        myuser = null,
        mycmp = null,
        myContact = null;

      if (user?.userrole === "customer") {
        mycust = user?.custcode;
      } else if (user?.userrole === "companyuser") {
        myuser = user?.cmpusercode;
      } else if (user?.userrole === "company") {
        mycmp = user?.companytransid;
      } else if (user.userrole === "customercontact") {
        myContact = user?.contactcode;
        // console.log("contactcode :", user?.contactcode);
      }

      const payload = {
        notesdescription: ticketData.ticketdescription,
        notesattachedfile: notesAttachedFile,
        ticketcode: detailTicketData?.ticket?.ticketcode,
        cmpusercode: myuser,
        custcode: mycust,
        companytransid: mycmp,
        contactcode: myContact,
      };

      const result = await saveNotes(payload);

      if (result.status === 201 && result.statusText === "Created") {
        ToastDisplayer("success", "Notes Created Successfully!");
        // Refresh ticket data to show new note
        const timeKey = getTimeFilterKey(timeFilter);

        await fetchFilteredNotes(noteFilter, timeKey);

        // Optional: Clear form fields
        setSliderOpen(false);
        setDescription("");
        setNotesAttachedFile("");
        setUploaderFiles([]);
        setMarkup("");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error ||
          "An unexpected error occurred while saving notes.",
      );
    } finally {
      setLoading(false);
    }
  };

  ///// trying to download attached file
  const renderNotesSection = (title, notes) => {
    if (notes?.length === 0) return null;

    const formatDate = (date) => {
      const formattedDate = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(new Date(date));

      const [day, month, year] = formattedDate.split(" ");
      return `${day} ${month} ${year}`;
    };

    const formatTime = (time) => {
      if (!time) return "";

      const [hours, minutes] = time.split(":");
      let h = parseInt(hours);

      const ampm = h >= 12 ? "PM" : "AM";
      h = h % 12 || 12;

      return `${h.toString().padStart(2, "0")}:${minutes} ${ampm}`;
    };

    //removed
    // const getMimeTypeAndExtension = (base64String) => {
    //   if (base64String.startsWith("/9j/")) {
    //     return { mimeType: "image/jpeg", extension: ".jpg" }; // JPEG
    //   } else if (base64String.startsWith("iVBORw0KGgo")) {
    //     return { mimeType: "image/png", extension: ".png" }; // PNG
    //   } else if (base64String.startsWith("JVBERi0x")) {
    //     return { mimeType: "application/pdf", extension: ".pdf" }; // PDF
    //   } else {
    //     return { mimeType: "application/octet-stream", extension: ".bin" }; // Default binary type
    //   }
    // };

    // const downloadAttachment = (base64String, filename) => {
    //   const base64Data = base64String.replace(/^data:.+;base64,/, "");

    //   // Extract actual MIME type from base64 string
    //   const match = base64String.match(/^data:(.*);base64,/);
    //   const mimeType = match ? match[1] : "application/octet-stream";

    //   // Map MIME type to file extension
    //   const extensionMap = {
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    //       ".xlsx",
    //     "application/vnd.ms-excel": ".xls",
    //     "application/msword": ".doc",
    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    //       ".docx",
    //     "application/pdf": ".pdf",
    //     "image/jpeg": ".jpg",
    //     "image/png": ".png",
    //     "image/jpg": ".jpg",
    //   };

    //   const extension = extensionMap[mimeType] || ".bin";

    //   // Convert base64 to Blob
    //   const byteCharacters = atob(base64Data);
    //   const byteArrays = [];
    //   for (let offset = 0; offset < byteCharacters?.length; offset += 1024) {
    //     const slice = byteCharacters.slice(offset, offset + 1024);
    //     const byteNumbers = new Array(slice?.length);
    //     for (let i = 0; i < slice?.length; i++) {
    //       byteNumbers[i] = slice?.charCodeAt(i);
    //     }
    //     const byteArray = new Uint8Array(byteNumbers);
    //     byteArrays.push(byteArray);
    //   }

    //   const blob = new Blob(byteArrays, { type: mimeType });

    //   // Download file with correct extension
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.download = `${filename}${extension}`;
    //   link.click();
    // };

    //   const downloadAttachment = (base64String, filename) => {
    //     const base64Data = base64String.replace(/^data:.+;base64,/, "");
    //     // 🧪 Log the file prefix to guess MIME
    // console.log("Base64 prefix:", base64String.substring(0, 30));

    // // 🧪 Log decoded length
    // console.log("Decoded size:", atob(base64Data).length);
    //     const { mimeType, extension } = getMimeTypeAndExtension(base64Data);
    //     const byteCharacters = atob(base64Data);
    //     const byteArrays = [];
    //     for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    //       const slice = byteCharacters.slice(offset, offset + 1024);
    //       const byteNumbers = new Array(slice.length);
    //       for (let i = 0; i < slice.length; i++) {
    //         byteNumbers[i] = slice.charCodeAt(i);
    //       }
    //       const byteArray = new Uint8Array(byteNumbers);
    //       byteArrays.push(byteArray);
    //     }
    //     const blob = new Blob(byteArrays, { type: mimeType });
    //     const link = document.createElement("a");
    //     link.href = URL.createObjectURL(blob);
    //     link.download = `${filename}${extension}`;
    //     link.click();
    //   };
    const openAttachmentInNewTab = (base64String) => {
      // Extract MIME type
      const match = base64String.match(/^data:(.*);base64,/);
      const mimeType = match ? match[1] : "application/octet-stream";

      // Convert base64 to Blob
      const base64Data = base64String.replace(/^data:.+;base64,/, "");
      const byteCharacters = atob(base64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
      }

      const blob = new Blob(byteArrays, { type: mimeType });

      // Create URL and open in new tab
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, "_blank");
    };

    return (
      <div className="actMain">
        <div className="actHead detail-small-bold">{title}</div>
        {notes &&
          // notes.map((note, index) => {
          [...notes]
            .sort((a, b) => {
              const dateA = new Date(
                `${a.notesdate} ${a.notestime || "00:00:00"}`,
              );
              const dateB = new Date(
                `${b.notesdate} ${b.notestime || "00:00:00"}`,
              );
              return dateA - dateB; // ascending (old → new)
            })
            .map((note, index) => {
              const isMyNote =
                note.notescreatedby?.toLowerCase().trim() ===
                user.login_name?.toLowerCase().trim();
              return (
                <div
                  key={index}
                  // ref={bottomRef}
                  className={`chatMessage ${isMyNote ? "chatRight" : "chatLeft"}`}
                >
                  <div className="chatContent">
                    <div className="chatHeader">
                      <span className="chatSender">
                        {note.notescreatedby || "Unknown"}
                      </span>

                      <span
                        className={`chatRole ${note.userrole
                          ?.toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {note.userrole}
                      </span>
                    </div>
                    <div className="chatTime">
                      {formatDate(note.notesdate)} {formatTime(note.notestime)}
                    </div>

                    <div
                      className="chatBubble"
                      dangerouslySetInnerHTML={{
                        __html: note.notesdescription,
                      }}
                    />
                    {note.notesattachedfile && (
                      <div className="chatAttachment">
                        <div
                          className="attachmentLink"
                          onClick={() =>
                            openAttachmentInNewTab(note.notesattachedfile)
                          }
                        >
                          <i className="ri-attachment-2"></i>
                          <span>View Attachment</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
      </div>
    );
  };

  //// rishabh code
  const handleTimeChange = (e) => {
    const selectedTime = e.value;
    setTimeFilter(selectedTime);

    const timeKey = getTimeFilterKey(selectedTime);

    fetchFilteredNotes(noteFilter, timeKey); // ✅ API CALL
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="notesContainer">
        <div className="queryMain ticket-card">
          {" "}
          <div className="ticket-subject">
            <b>{`${detailTicketData?.ticket?.ticketsubject || ""}`}</b>
          </div>
        </div>
        <div className="notesSec">
          <div className="notesHead">
            <div className="notesLeft">
              <SelectBox
                stylingMode="outlined"
                dataSource={timeDataSource}
                value={timeFilter}
                displayExpr="name"
                valueExpr="value"
                placeholder="All Time"
                width={180}
                height={44}
                onValueChanged={(e) => {
                  const selectedTime = e.value;
                  setTimeFilter(selectedTime);

                  const timeKey = getTimeFilterKey(selectedTime);

                  fetchFilteredNotes(noteFilter, timeKey); // ✅ API CALL
                }}
              />

              <SelectBox
                stylingMode="outlined"
                dataSource={roleBasedFilters}
                value={noteFilter}
                displayExpr="name"
                valueExpr="value"
                placeholder="All Notes"
                width={200}
                height={44}
                onValueChanged={(e) => {
                  setNoteFilter(e.value);
                  fetchFilteredNotes(e.value);
                }}
              />
            </div>
            {!isTicketClosed && (
              <div className="notesRight">
                <div className="addNotes" onClick={handleAddNote}>
                  <i className="ri-add-box-fill"></i>
                  <span className="detail-small-bold">Add Note</span>
                </div>
              </div>
            )}
            {/* <div className="notesFooter">
              <Button
                text="Add Note"
                icon="plus"
                type="default"
                stylingMode="contained"
                onClick={handleAddNote}
                className="addNoteBtn"
              />
            </div> */}
          </div>
          <div className="notesBody">
            {filteredNotes.length === 0 ? (
              <CustomEmpty moduleName="Notes" />
            ) : (
              renderNotesSection("Notes", filteredNotes)
            )}
          </div>
        </div>
      </div>

      <CustomSlider
        isOpen={isSliderOpen}
        isSlidingOut={isSlidingOut}
        onClose={handleCloseSlider}
        headtext={"Add Notes"}
        setSliderOpen={setSliderOpen}
        setIsSlidingOut={setIsSlidingOut}
      >
        <div className="notesMainDrawer">
          <div className="noteDrawerBody">
            <div className="noteHeadDrawer typ-sub-text">
              Please provide note's details below
            </div>
            <div className="notesDrawerDesc">
              <div className="notesItem">
                {/* <label className="noteDrawerLabel">Description</label> */}
                <div className="descSec">
                  <label className="descLabel">
                    Description <span className="requiredClass">*</span>
                  </label>
                  <CustomHtmlEditor markup={markup} setMarkup={setMarkup} />
                </div>
                {/* <TextArea
                  stylingMode="outlined"
                  placeholder="Add Description"
                  height={"200"}
                  value={description}
                  onValueChanged={(e) => setDescription(e.value)}
                /> */}
              </div>
              <div className="notesItem">
                {/* <label className="noteDrawerLabel">Attachment</label> */}
                <FileUploader
                  className="noteFileSec"
                  // stylingMode="underlined"
                  multiple={false}
                  value={uploaderFiles}
                  maxFileSize={5000000}
                  // allowedFileExtensions={[".jpg", ".png", ".jpeg", ".pdf"]}
                  allowedFileExtensions={[
                    ".jpg",
                    ".png",
                    ".jpeg",
                    ".pdf",
                    ".doc",
                    ".docx",
                    ".xls",
                    ".xlsx",
                  ]}
                  onValueChanged={handleFileChange}
                  labelText="Upload Format (jpg, png, jpeg, pdf, doc, docx, xls, xlsx)"
                />
              </div>
            </div>
          </div>

          <div className="notesFootDrawer">
            <div className="btnSection">
              <div className="cancelSection">
                <Button
                  text="Cancel"
                  height={"40px"}
                  onClick={handleCloseSlider}
                />
              </div>

              <div className="create-button">
                <CustomButton
                  text={"Send Note"}
                  onClick={handleNotesSaveDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </CustomSlider>
    </>
  );
}
